import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signoutAnalytics } from '../accountPageUtils';
import AccountHeader from '../Presentation/AccountHeader';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { getTernaryValue, isEmptyEvery } from 'common/utilities/utils';
import { CateringMenuNavigationHandler } from 'common/utilities/CateringPLPUtils';
import { UserOrderContext } from 'context/context';

export const signOutHandler = (userParams, basicData, dispatch, userOrderStateDispatch, dispositionNew) => {
  signoutAnalytics(basicData?.id);
  CateringMenuNavigationHandler(null, null, userParams, dispatch, userOrderStateDispatch, null, dispositionNew, true);
  AuthManager.getInstance().logout();
  localStorage.removeItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER);
};

const AccountHeaderContainer = props => {
  const basicData = useSelector(data => data.profileReducer?.basic || null);
  const dispatch = useDispatch();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const dispositionNew = getTernaryValue(
    isEmptyEvery(userOrderState.dispositionNew),
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW)),
    userOrderState.dispositionNew,
  );
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);

  const signOutAccount = () => {
    // analytics for saving preferences
    signOutHandler(userParams, basicData, dispatch, userOrderStateDispatch, dispositionNew);
  };

  return <AccountHeader {...props} signOutAccount={signOutAccount} basicData={basicData} />;
};

export default AccountHeaderContainer;
